import { useMutation } from 'react-query';
import { toastr } from 'react-redux-toastr';
import { submitTenantEvents } from '../../services/tracsService';
import messages from './messages';

const useSubmitTenantEventsToTracsMutation = ({
  normalizedTenantEvents,
  effectiveSubmissionStatus,
  intl,
  invalidateVoucherDetailQueries,
  startHudAsyncDataRefresh,
  onSubmittedVoucherReverted,
  voucherId,
}) => {
  return useMutation(
    async ({ wassId, password }) => {
      const eligible = normalizedTenantEvents.filter(
        (e) => e.certComplete === 'Yes',
      );
      const tenantEventIds = eligible.map((e) => e.id).filter(Boolean);

      if (tenantEventIds.length === 0) {
        throw new Error('No eligible tenant events');
      }

      return submitTenantEvents({
        tenantEventIds,
        username: wassId,
        password,
        voucherId,
      });
    },
    {
      onSuccess: () => {
        toastr.success('Success', 'Tenant events submitted to TRACS.');

        void invalidateVoucherDetailQueries();
        startHudAsyncDataRefresh();

        if (effectiveSubmissionStatus === 'Submitted') {
          onSubmittedVoucherReverted();
          toastr.warning(
            intl.formatMessage(messages.voucherStatusUpdatedTitle),
            intl.formatMessage(messages.voucherReturnedToDraftWarning),
          );
        }
      },
      onError: (err) => {
        const message =
          err?.error ||
          err?.message ||
          err?.networkError ||
          (typeof err === 'string' ? err : 'Failed to submit tenant events.');

        toastr.error('Error', message);
        void invalidateVoucherDetailQueries();
      },
    },
  );
};

export default useSubmitTenantEventsToTracsMutation;
